import React from "react";
import { IntendedUsePageContent } from "@swo/storefront";

import { IntendedUseStoryItemCard } from "./boxes/IntendedUseStoryItemCard";
import { IntendedUseBoxItemCard } from "./boxes/IntendedUseBoxItemCard";
import { IntendedUseProductItemCard } from "./boxes/IntendedUseProductItemCard";

export const IntendedUseCardItem: React.FC<{
  card: IntendedUsePageContent["items"][number];
}> = React.memo(({ card }) => {
  switch (card.type) {
    case "product-item": {
      return <IntendedUseProductItemCard card={card} />;
    }
    case "box-item": {
      return <IntendedUseBoxItemCard card={card} />;
    }
    case "story-item": {
      return <IntendedUseStoryItemCard card={card} />;
    }
    default: {
      const _: never = card;
      return _;
    }
  }
});
